import { useCallback, useMemo } from 'react';
import useMetadata from '../useMetadata';

export default function useTransportMethod() {
  const {
    state: metadataState,
    selectors: { selectTransportMethod },
  } = useMetadata();

  // TODO: use this function in useOrderDetails.ts
  const displayTransportMethod = useCallback(
    (value) => {
      const transportMethod = selectTransportMethod(metadataState, value);

      return transportMethod ? transportMethod.label : '';
    },
    [metadataState, selectTransportMethod],
  );

  return useMemo(
    () => ({
      displayTransportMethod,
    }),
    [displayTransportMethod],
  );
}
